import request from '@/utils/request'

// 专题
export const getfortyTopicList = (page_size, type, grouptype) => {
  return request({
    method: 'GET',
    url: '/zt/fortyTopic/page?page=1&page_size='+page_size + '&topic_type=' + type + '&group_type=' + grouptype
  })
}

//点击量
export const addClicks = (id) => {
  return request({
    method: 'GET',
    url: '/zt/fortyTopic/addClicks/'+id
  })
}
//详情
export const ztdetail = (id) => {
  return request({
    method: 'GET',
    url: '/zt/fortyTopic/detail/'+id
  })
}